import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { FaSearch, FaTimes, FaPlus } from 'react-icons/fa';

const NewGroupModal = ({
  show, onClose, groupName, setGroupName,
  selectedUsers, toggleUserSelection,
  searchQuery, onSearch, searchUsers, onCreateGroup
}) => (
  <AnimatePresence>
    {show && (
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        className="fixed inset-0 bg-black/50 z-50 flex items-center justify-center p-4"
        onClick={onClose}
      >
        <motion.div
          initial={{ scale: 0.95 }}
          animate={{ scale: 1 }}
          exit={{ scale: 0.95 }}
          onClick={e => e.stopPropagation()}
          className="bg-white rounded-2xl w-full max-w-md p-6"
        >
          <div className="flex items-center justify-between mb-4">
            <h2 className="text-xl font-bold text-gray-900">New Group</h2>
            <button onClick={onClose} className="text-gray-500 hover:text-gray-700">
              <FaTimes />
            </button>
          </div>

          <div className="mb-4">
            <label className="text-sm text-gray-600 mb-1 block">Group Name</label>
            <input
              type="text"
              value={groupName}
              onChange={(e) => setGroupName(e.target.value)}
              placeholder="Enter group name..."
              className="w-full px-4 py-3 bg-gray-100 border-none rounded-xl focus:outline-none focus:ring-2 focus:ring-[#4A90E2]"
            />
          </div>

          {selectedUsers.length > 0 && (
            <div className="mb-4">
              <label className="text-sm text-gray-600 mb-2 block">Selected ({selectedUsers.length})</label>
              <div className="flex flex-wrap gap-2">
                {selectedUsers.map(user => (
                  <span key={user.id} className="flex items-center space-x-1 bg-[#4A90E2]/10 text-[#4A90E2] px-3 py-1 rounded-full text-sm">
                    <span>{user.full_name}</span>
                    <button onClick={() => toggleUserSelection(user)} className="hover:text-red-500">
                      <FaTimes size={10} />
                    </button>
                  </span>
                ))}
              </div>
            </div>
          )}

          <div className="relative mb-4">
            <FaSearch className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" />
            <input
              type="text"
              placeholder="Add members..."
              value={searchQuery}
              onChange={(e) => onSearch(e.target.value)}
              className="w-full pl-10 pr-4 py-3 bg-gray-100 border-none rounded-xl focus:outline-none focus:ring-2 focus:ring-[#4A90E2]"
            />
          </div>

          <div className="max-h-48 overflow-y-auto mb-4">
            {searchUsers.filter(u => !selectedUsers.find(s => s.id === u.id)).map(user => (
              <div
                key={user.id}
                onClick={() => toggleUserSelection(user)}
                className="flex items-center space-x-3 p-3 hover:bg-gray-50 rounded-lg cursor-pointer"
              >
                <img
                  src={user.avatar_url || 'https://images.pexels.com/photos/220453/pexels-photo-220453.jpeg'}
                  alt={user.full_name}
                  className="w-10 h-10 rounded-full object-cover"
                />
                <div className="flex-1">
                  <p className="text-gray-900 font-medium">{user.full_name}</p>
                  <p className="text-gray-500 text-sm">@{user.username}</p>
                </div>
                <FaPlus className="text-[#4A90E2]" />
              </div>
            ))}
          </div>

          <button
            onClick={onCreateGroup}
            disabled={!groupName.trim() || selectedUsers.length < 1}
            className="w-full bg-gradient-to-r from-[#4A90E2] to-[#A855F7] text-white py-3 rounded-xl font-medium transition-opacity hover:opacity-90 disabled:opacity-50"
          >
            Create Group
          </button>
        </motion.div>
      </motion.div>
    )}
  </AnimatePresence>
);

export default NewGroupModal;
